import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ProblemSection from "./components/ProblemSection";
import HowItWorks from "./components/HowItWorks";
import WorthScore from "./components/WorthScore";
import RennMoves from "./components/RennMoves";
import Missions from "./components/Missions";
import AskRenn from "./components/AskRenn";
import WeeklyCheckin from "./components/WeeklyCheckin";
import ScenarioPlanner from "./components/ScenarioPlanner";
import Military from "./components/Military";
import Personality from "./components/Personality";
import Security from "./components/Security";
import BetaSection from "./components/BetaSection";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import StickyBetaButton from "./components/StickyBetaButton";
import LegalPage from "./components/LegalPage";
import AdminPage from "./components/AdminPage";
import { Toaster } from "./components/ui/toaster";

const Landing = () => (
  <div className="App renn-bg">
    <div className="relative z-10">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <HowItWorks />
        <WorthScore />
        <RennMoves />
        <Missions />
        <AskRenn />
        <WeeklyCheckin />
        <ScenarioPlanner />
        <Military />
        <Personality />
        <Security />
        <BetaSection />
        <Testimonials />
        <FaqSection />
        <FinalCTA />
      </main>
      <Footer />
      <StickyBetaButton />
      <Toaster />
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/legal/:slug" element={<LegalPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
